<app-mb-card>
  <header>
    <h2>Licencias</h2>
    <p>Aquí podrás administrar todas las licencias de las compañías registradas en mBase. Podrás listar, añadir o editar licencias.</p>
  </header>
</app-mb-card>
<app-mb-card class="list-card">
  <header>
    <div>
      <h3>Listado de licencias</h3>
      <div class="list-actions">
        @if (filteredLicenses?.length > 0) {
          <app-mb-button flat (click)="exportCsv()">Exportar</app-mb-button>
        }
        <input
          class="table-filter"
          type="text"
          placeholder="Filtrar..."
          [value]="filterQuery"
          (input)="onFilterQueryChange($any($event.target).value)"
        >
        <label class="finished-filter">
          <input
            type="checkbox"
            [checked]="showFinished"
            (change)="onShowFinishedChange($any($event.target).checked)"
          >
          Mostrar expiradas
        </label>
        <app-mb-button [routerLink]="['/license']">Crear licencia</app-mb-button>
      </div>
    </div>
    @if (filteredLicenses?.length > 0) {
      <app-mb-table>
        <table>
          <thead>
            <tr>
              <th></th>
              <th class="sortable" (click)="setSort('description')">Nombre <span>{{ sortIndicator('description') }}</span></th>
              <th class="sortable" (click)="setSort('companyName')">Compañía <span>{{ sortIndicator('companyName') }}</span></th>
              <th class="sortable" (click)="setSort('startDateMillis')">Fecha inicio <span>{{ sortIndicator('startDateMillis') }}</span></th>
              <th class="sortable" (click)="setSort('endDateMillis')">Fecha fin <span>{{ sortIndicator('endDateMillis') }}</span></th>
              <th class="sortable" (click)="setSort('quantity')">Disponibles <span>{{ sortIndicator('quantity') }}</span></th>
              <th>Usadas</th>
              <th>Centro</th>
              <th>Aplicación</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            @for (license of filteredLicenses; track license) {
              <tr [ngClass]="{ 'expired': isExpired(license.endDateMillis), 'expiring': isExpiringSoon(license.endDateMillis) }">
                <td [title]="license.active ? 'Activado' : 'Desactivado'">
                  @if (license.active) {
                    <i class="fas fa-check-circle"></i>
                  }
                  @if (!license.active) {
                    <i class="fas fa-times"></i>
                  }
                </td>
                <td [title]="license.description">{{ license.description }}</td>
                <td [title]="license.companyName">{{ license.companyName }}</td>
                <td [title]="license.startDateMillis">{{ license.startDateMillis | dateUnixTransformer:'false' }}</td>
                <td [title]="license.endDateMillis">{{ license.endDateMillis | dateUnixTransformer:'false' }}</td>
                <td [title]="license.quantity">{{ license.quantity > 0 ? license.quantity : 'Ilimitadas'}}</td>
                <td [title]="license.inUse">{{ license.inUse }}</td>
                <td [title]="license.centerName || 'Todos los centros'">{{ license.centerName || 'Todos' }}</td>
                <td [title]="license.applicationName || 'Todas las aplicaciones'">{{ license.applicationName || 'Todas' }}</td>
                <td class="options">
                  <app-mb-button flat tooltip="licenseMenu">
                    <i class="fas fa-ellipsis-h"></i>
                  </app-mb-button>
                  <app-mb-tooltip class="licenseMenu">
                    <app-mb-button flat [routerLink]="['/license', license.internalId]">Ver</app-mb-button>
                    <app-mb-button flat error (click)="deleteLicense(license)">Eliminar</app-mb-button>
                  </app-mb-tooltip>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </app-mb-table>
    }
    @if (!(filteredLicenses?.length > 0)) {
      <p class="empty-state">
        {{ showFinished ? 'No hay licencias para mostrar.' : 'No hay licencias vigentes.' }}
      </p>
    }
  </header>
</app-mb-card>
@if (pendingDeleteLicense) {
  <app-mb-confirm-dialog
    [title]="'Eliminar licencia'"
    [message]="'¿Seguro que quieres eliminar ' + (pendingDeleteLicense.description || 'esta licencia') + '? Esta acción no se puede deshacer.'"
    [confirmText]="'Eliminar'"
    [cancelText]="'Cancelar'"
    (confirmed)="confirmDeleteLicense()"
    (cancelled)="cancelDeleteLicense()"
  ></app-mb-confirm-dialog>
}
